export default "__VITE_ASSET__ee8ee421__"